var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('custom-field-template-create-rule',{on:{"add-rule":_vm.addRule}}),_vm._l((_vm.rules),function(rule){return _c('custom-field-template-existing-rule',{key:`rule-${rule.custom_field_template_id}-${rule.operator}-${rule.custom_field_value}`,attrs:{"rule":rule},on:{"remove-rule":_vm.removeRule}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }